import { UseFormReturn, useWatch } from "react-hook-form";
import { Alert, Box } from "@mui/material";

export const MonthdaysCapWarning = ({
	entityForm,
	frequencyItem
}: {
	entityForm: UseFormReturn;
	frequencyItem: string;
}) => {
	const control = entityForm?.control;

	const frequency = useWatch({ control, name: "run_at_frequency" }) ?? frequencyItem;
	const monthdays = useWatch({ control, name: "run_at_monthdays" });

	const isMonthdaysRelevant = frequency === "monthly" || frequency === "annual";
	const hasCappedDay = Array.isArray(monthdays) && monthdays.some((day) => Number(day) >= 29);

	if (!isMonthdaysRelevant || !hasCappedDay) return null;

	return (
		<Box sx={{ px: 4, pt: 2 }}>
			<Alert severity="info">
				Os dias 29, 30 e 31 são ajustados automaticamente para o último dia do mês nos meses mais curtos (por
				exemplo, fevereiro). Se pretender exatamente o último dia de cada mês, selecione 31.
			</Alert>
		</Box>
	);
};
